import React from 'react';

import { CardModal } from 'components/card-modal';
import { IClaimPointsScreenContentFragment, Maybe } from 'generated/sanity-graphql';
import { spacing } from 'styles/constants';

import {
  Button,
  ClaimsPointContent,
  MainImage,
  StyledLink,
  Text,
  Title,
} from './loyalty-claim-points.styled';

export type LoyaltyClaimPointsViewButtonConfig = {
  hidden?: boolean;
  asLink?: boolean;
};

interface ILoyaltyClaimPointsViewProps {
  content?: IClaimPointsScreenContentFragment | null;
  children?: React.ReactNode;
  onPress: (str?: string | null) => void;
  topButtonConfig?: LoyaltyClaimPointsViewButtonConfig;
  bottomButtonConfig?: LoyaltyClaimPointsViewButtonConfig;
}

type IButton = {
  label?: Maybe<string>;
  url?: Maybe<string>;
} & LoyaltyClaimPointsViewButtonConfig;

const LoyaltyClaimPointsView = ({
  content,
  children,
  onPress,
  topButtonConfig,
  bottomButtonConfig,
}: ILoyaltyClaimPointsViewProps) => {
  const topButton: IButton = {
    label: content?.topButtonTitle?.locale,
    url: content?.topButtonUrl?.locale,
    ...topButtonConfig,
  };
  const bottomButton: IButton = {
    label: content?.bottomButtonTitle?.locale,
    url: content?.bottomButtonUrl?.locale,
    ...bottomButtonConfig,
  };

  return (
    <CardModal
      standardPadding
      alwaysShowHeader
      scrollView
      footer={
        <>
          {[topButton, bottomButton].map(
            ({ label, url, asLink, hidden }, idx) =>
              !hidden &&
              label &&
              url &&
              (asLink ? (
                <StyledLink key={label} to={url} style={idx === 0 && { marginBottom: spacing.$4 }}>
                  {label}
                </StyledLink>
              ) : (
                <Button
                  fullWidth
                  key={label}
                  onPress={() => onPress(url)}
                  style={idx === 0 && { marginBottom: spacing.$4 }}
                >
                  {label}
                </Button>
              ))
          )}
        </>
      }
    >
      {content?.rewardsIcon && (
        <MainImage
          alt={content.screenTitle?.locale || ''}
          image={content.rewardsIcon.locale}
          height="50px"
        />
      )}
      {content?.secondImage && (
        <MainImage
          alt={content.screenTitle?.locale || ''}
          image={content.secondImage?.locale}
          height="130px"
        />
      )}
      <Title>{content?.screenTitle?.locale}</Title>
      <Text content={content?.instructionsTextBlock?.localeRaw} textAlign={{ md: 'center' }} />

      <ClaimsPointContent>{children}</ClaimsPointContent>
    </CardModal>
  );
};

export default LoyaltyClaimPointsView;
